import { Box, Button, Container, Stack, Typography } from "@mui/material"
import { Link } from "react-router-dom"

import NavbarOffset from "./NavbarOffset"
import { overlineSx, pillButtonSx } from "../styles/sectionStyles"

const HeroHeader = ({
    background,
    backgroundPosition = "center",
    overline,
    title,
    subtitle,
    maxWidth = 640,
    cta,
}) => (
    <Box
        component="section"
        sx={{
            position: "relative",
            color: "#fff",
            overflow: "hidden",
            backgroundImage: `
                linear-gradient(
                    105deg,
                    rgba(0, 4, 53, 0.94) 0%,
                    rgba(0, 4, 53, 0.8) 48%,
                    rgba(0, 4, 53, 0.48) 100%
                ),
                url('${background}')
            `,
            backgroundSize: "cover",
            backgroundPosition,
            backgroundRepeat: "no-repeat",
        }}
    >
        <Box
            sx={{
                position: "absolute",
                inset: 0,
                background:
                    "radial-gradient(ellipse 55% 70% at 88% 42%, rgba(0, 163, 255, 0.16), transparent 58%)",
                pointerEvents: "none",
            }}
        />

        <NavbarOffset />

        <Container maxWidth="lg" sx={{ position: "relative", py: { xs: 6, md: 8 } }}>
            <Stack
                spacing={2.5}
                maxWidth={maxWidth}
                data-aos="fade-up"
                data-aos-duration="800"
            >
                <Typography variant="overline" sx={overlineSx}>
                    {overline}
                </Typography>

                <Typography
                    variant="h2"
                    fontWeight={800}
                    sx={{
                        fontSize: { xs: "2.35rem", sm: "3rem", md: "3.35rem" },
                        lineHeight: 1.08,
                    }}
                >
                    {title}
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        opacity: 0.82,
                        lineHeight: 1.7,
                        fontSize: { xs: "1.05rem", md: "1.125rem" },
                        maxWidth: 520,
                    }}
                >
                    {subtitle}
                </Typography>

                {cta && (
                    <Box pt={0.5}>
                        {cta.href ? (
                            <Button
                                component={Link}
                                to={cta.href}
                                target={cta.external ? "_blank" : undefined}
                                rel={cta.external ? "noopener noreferrer" : undefined}
                                variant="contained"
                                color="secondary"
                                size="large"
                                onClick={cta.onClick}
                                sx={{ ...pillButtonSx, px: 3.5, py: 1.35 }}
                            >
                                {cta.label}
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                onClick={cta.onClick}
                                sx={{ ...pillButtonSx, px: 3.5, py: 1.35 }}
                            >
                                {cta.label}
                            </Button>
                        )}
                    </Box>
                )}
            </Stack>
        </Container>
    </Box>
)

export default HeroHeader
